// extracted by mini-css-extract-plugin
export default {"main":"_901caee31b _148977ef3a","xmark":"_70082c2f39","fl_img":"_4e60aed76d a2cce0ccce"};